import { Navigate, Route, Routes } from 'react-router-dom';
import { Spinner, useAuth } from '@mobi/web';
import { Auth } from './pages/Auth.js';
import { Home } from './pages/Home.js';
import { Earnings } from './pages/Earnings.js';
import { Profile } from './pages/Profile.js';
import { Shell } from './components/Shell.js';

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-app grid place-items-center bg-surface text-brand">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (!user) return <Auth />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Home />} />
        <Route path="/ganhos" element={<Earnings />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
